import PhotoGallery from './components/PhotoGallery';
import ProductInfo from './components/ProductInfo';
import { useLocation } from "react-router-dom";
import { useEffect } from 'react';
const EquipmentPage = () => {
  const location = useLocation();
  const data = location.state;

  useEffect(() => {


  }, [])
  return (
    <div className="mt-3 grid h-full w-full grid-cols-12 gap-3 rounded-[20px] bg-white bg-clip-border p-[18px] shadow-3xl shadow-shadow-500 dark:shadow-none dark:!bg-navy-800">
      <div className="col-span-12 h-full w-full xl:col-span-7">
        {/* image */}
        <PhotoGallery images={data.equipment.images} />
      </div>

      <div className="col-span-12 w-full xl:col-span-5">
        <ProductInfo equipment={data.equipment} images={data.equipment.images} />
      </div>
    </div>
  );
};

export default EquipmentPage;
